import { defineMessages } from "react-intl";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import CommonFieldName from "./CommonFieldName";
import DateTimeField from "./impl/DateTimeField";
import FieldModel from "./impl/FieldModel";
import { createField } from "./impl/fieldModelUtil";
import NameField from "./impl/NameField";

export enum GroupFieldName {
  NAME = CommonFieldName.NAME,
  COLOR = CommonFieldName.COLOR,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
}

const displayNames = defineMessages<GroupFieldName>({
  [GroupFieldName.COLOR]: {
    id: "group.field.color",
    defaultMessage: "Color",
    description: "Color field of group",
  },
  [GroupFieldName.NAME]: {
    id: "group.field.name",
    defaultMessage: "Name",
    description: "Name field of group",
  },
  [GroupFieldName.UPDATED_AT]: {
    id: "group.field.updatedAt",
    defaultMessage: "Date Last Modified",
    description: "Modified At field of group",
  },
});

const groupFieldModel = new FieldModel(
  [
    new NameField({
      displayName: displayNames[GroupFieldName.NAME],
      name: GroupFieldName.NAME,
    }),
    {
      customGridProperties: {
        cellRenderer: "colorCellRenderer",
      },
      displayName: displayNames[GroupFieldName.COLOR],
      features: [FieldFeature.SORTABLE, FieldFeature.FILTERABLE],
      name: GroupFieldName.COLOR,
      type: FieldType.STRING,
    },
    new DateTimeField({
      displayName: displayNames[GroupFieldName.UPDATED_AT],
      name: GroupFieldName.UPDATED_AT,
    }),
  ].map(createField)
);

export default groupFieldModel;
